import { useEffect } from "react";
import { Route, Routes } from "react-router";
import { loadSpeechstream } from "@imaginelearning/mps-ux-component-library";
import { AssessmentProvider } from "../context/assessment-provider";
import AssessmentCourseMap from "../assessment-course-map";
import DiagnosticReturn from "../diagnostics/diagnostic-return";

function AssessmentContainer() {
  useEffect(() => {
    const initialLoad = () => {
      try {
        loadSpeechstream();
      } catch (e) {
        console.error("Error loading speechstream", e);
      }
    };
    initialLoad();
  }, []);

  return (
    <AssessmentProvider>
      <Routes>
        <Route path="/*" element={<AssessmentCourseMap />} />
        <Route path="/diagnostic-return" element={<DiagnosticReturn />} />
      </Routes>
    </AssessmentProvider>
  );
}

export default AssessmentContainer;
